import { View, Text, Image } from "@react-pdf/renderer";
import styles from "./styles";
import FaNum from "./FaNum";

export default function InvoiceHeader({ order }) {
  return (
    <View style={styles.header}>
      <View style={styles.titleBox}>
        <Text style={styles.titleText}>فاکتور فروش</Text>
      </View>

      <View style={styles.orderInfo}>
        <View style={styles.orderRow}>
          <Text style={styles.orderStrong}>: شناسه سفارش </Text>
          <FaNum>{order.data.id}</FaNum>
        </View>

        <View style={styles.orderRow}>
          <Text style={styles.orderStrong}>: تاریخ سفارش </Text>
          <FaNum>{order.data.order_date}</FaNum>
        </View>
      </View>

      <View style={styles.barcodeBox}>
        <Image src="/images/icons/barcode.png" style={styles.barcodeImage} />
      </View>
    </View>
  );
}
